// extracted by mini-css-extract-plugin
var _1 = "E1oRoriYMVzOenIhqler";
export { _1 as "root" }
